import { I18nUtils } from '../../../../i18n/I18nUtils';

export class Password {
    _password;

    constructor(password) {
        if ( !password )
            throw new Error(I18nUtils.tr('TR_CAMPO_OBLIGATORIO'));

        this._password = password;
    }

    get password() {
        return this._password;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/objectvalue/Password.js